import React from 'react';
import { Link } from 'react-router-dom';
import './styles.css';

export default function SignupGatePage() {
  return (
    <div className="signup-gate-page">
      <section className="signup-gate-card card">
        <h1>Energia Gratuita Esgotada</h1>
        <p>Você usou toda sua energia grátis. Crie sua conta para continuar gerando criativos sem perder sua evolução.</p>

        <ul className="signup-gate-benefits">
          <li>Salvar criativos e histórico permanentemente</li>
          <li>Continuar editando com chat inteligente</li>
          <li>Acessar dashboard completo e conteúdos</li>
        </ul>

        <div className="signup-gate-actions">
          <Link to="/login" className="btn btn-secondary">Login</Link>
          <Link to="/signup" className="btn btn-primary">Criar Conta</Link>
        </div>
      </section>
    </div>
  );
}
